import React from 'react';

export default function Resume() {
  return (
    <div style={{ height: '100%', padding: '1rem' }}>
      <iframe
        src="/icons/Suhani Surya PM Resume Summer 2026.pdf"
        title="Suhani Surya Resume"
        style={{
          width: '100%',
          height: '90vh',
          border: 'none',
        }}
      />
    </div>
  );
}
